import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { IReactMarkdownProps } from "./ReactMarkdown.props";
import styles from "./ReactMarkdown.module.scss";

const ReactMarkdown = ({ children, ...props }: IReactMarkdownProps): JSX.Element => {
	return (
		<Markdown
			remarkPlugins={[remarkGfm]}
			components={{
				table(props) {
					const { node, ...rest } = props;
					return <table className={styles.table} {...rest} />;
				},
			}}
			{...props}
		>
			{children}
		</Markdown>
	);
};

export default ReactMarkdown;
